/**
 * Animation class constants. These match custom @keyframes rules defined in
 * src/index.css (~lines 165-300) — animate.css is NOT installed as a
 * dependency. Do not add animate.css; these strings are the canonical source.
 */

export const FADE_IN = 'animate__animated animate__fadeIn';

export const FADE_IN_SLOWER = 'animate__animated animate__fadeIn animate__slower';
